<template>
  <div class="move-group">
    <div class="format-content">
      <v-card>
        <div class="header">
          <v-card-title>
            <span>Move to Group {{ vehicleCountMsg }}</span> 
            <v-spacer/> 
            <v-icon color="white" @click="close">mdi-close</v-icon>
          </v-card-title>
        </div>
        
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select 
                v-model="selectedGroup"
                label="Group" 
                :items="groups"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          
          <v-btn text color="#0f74bb" @click="close">
            cancel
          </v-btn>
          <v-spacer/>
          <v-btn text color="#0f74bb" :loading="loading" :disabled="disableSubmit || loading" @click="moveVehicles">
            move
          </v-btn>
        </v-card-actions>
      </v-card>
      
    </div>    
  </div>
</template>

<script>

import { AssignBatchVehiclesToNode } from "@/services/API.js";

import { AmplifyEventBus } from "aws-amplify-vue"

// import { Logger } from "aws-amplify";
// 	const logger = new Logger("MoveVehicleToNewGroup");

export default {
  name: 'MoveVehicleToNewGroup',
  props: {
    groups: {
      type: Array,
      required: true
    },
    orgId: {
      type: String,
      required: true
    },
    vehicleList: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      selectedGroup: null,
      orgTreeLoading: false,
      orgGroups: [],
      loading: false
    }
  },
  
  computed: {
    vehicleCountMsg() {
     if(this.vehicleList.length == 1) {
      return `(1 vehicle selected)`
     }
     else if(this.vehicleList.length > 1) {
      let count = this.vehicleList.length
      return `(${count} vehicles selected)`
     }
     else {
      return ''
     }
    },


    disableSubmit() {
      return !this.selectedGroup ? true : false;
    },

    vehicleIdList() {
      const vehicles = this.vehicleList.map(vehicle => vehicle.id)

      return vehicles
    },

    payload() {
      const payload = {
        node_id: this.selectedGroup,
        vehicle_ids: this.vehicleIdList
      }

      return payload
    }
  },


  methods: {
    close() {
      this.$emit('close')
    },

    async moveVehicles() {
      this.loading = true 

      try {
        const move = await AssignBatchVehiclesToNode(this.orgId, this.selectedGroup, this.payload)

        if (move) {
          setTimeout(() => {
            this.loading = false
            this.$emit('success')
            this.close()
          }, 1000)
        }
      } catch {
        this.loading = false
        
        AmplifyEventBus.$emit("snackEvent", {
          color: "error",
          text: 'An error occured'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .move-group {
    z-index: 9998;
    position: fixed;
    left: 0%;
    right: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.4) !important;
    width: 100vw;
    height: 100vh;

    .format-content {
      background: #0f74bb ;
      margin: 0;
      position: relative;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      padding: 0;
      overflow: hidden;
      border: solid grey 2px;
      width: 500px;

      .header {
        background: #0f74bb ;
        color: white;
      }
    }
  }
</style>